import { Button, Fa } from '@eltoro-ui/components'

interface FeatureDisabledMessageProps {
  featureName: string
  onClose: () => void
}

export const FeatureDisabledMessage = ({
  featureName,
  onClose,
}: FeatureDisabledMessageProps) => {
  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="bg-warning-50 text-warning border-warning rounded-md border-2 p-4">
        <div className="mb-2 flex items-center gap-2">
          <Fa icon="exclamation-triangle" size={2} />
          <p className="text-lg font-bold">Feature Currently Disabled</p>
        </div>
        <p className="mb-3">
          {featureName} are currently disabled for this organization.
        </p>
        <p className="mb-2">Please contact our support team directly:</p>
        <a
          href="mailto:support@eltoro.com"
          className="text-primary text-lg font-semibold underline"
        >
          support@eltoro.com
        </a>
      </div>
      <div className="ml-auto flex gap-4">
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  )
}
